module.exports = __webpack_public_path__ + "img/mp-cartrecovery-yt-cover.47bf21a2.png";